import { render, staticRenderFns } from "./RealEstateRentContracts.vue?vue&type=template&id=213b2b38&scoped=true&"
import script from "./RealEstateRentContracts.vue?vue&type=script&lang=js&"
export * from "./RealEstateRentContracts.vue?vue&type=script&lang=js&"
import style0 from "./RealEstateRentContracts.vue?vue&type=style&index=0&id=213b2b38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "213b2b38",
  null
  
)

export default component.exports